import { MarketplaceProgramStatus } from '@atlassian/mpac-types/dist/GraphQLGateway.gql.types';
/**
 * Adapter which takes in REST + GraphQL Data & aggregates them
 * to provide a single source of data consumption for privacy & security tab
 *
 * REST Endpoint is temporary & we expect everything to be moved within
 * the GraphQL response in future, this should help make the transition simpler.
 *
 * Check './README.md' to know more.
 */
const appTrustDataAdapter = (appListingGql, trustDataApi) => {
  var _appListingGql$progra, _appListingGql$progra2, _appListingGql$progra3, _appListingGql$progra4;
  return {
    // TODO: Sancus - Confirm with backend if "Yes" should be shown for only "Approved" status.
    // Other statuses are "rejected" & "not_a_participant"
    isCloudBugBountyParticipant: ((_appListingGql$progra = appListingGql.programs) === null || _appListingGql$progra === void 0 ? void 0 : (_appListingGql$progra2 = _appListingGql$progra.bugBountyParticipant) === null || _appListingGql$progra2 === void 0 ? void 0 : (_appListingGql$progra3 = _appListingGql$progra2.cloud) === null || _appListingGql$progra3 === void 0 ? void 0 : _appListingGql$progra3.status) === MarketplaceProgramStatus.Approved,
    cloudFortified: (_appListingGql$progra4 = appListingGql.programs) === null || _appListingGql$progra4 === void 0 ? void 0 : _appListingGql$progra4.cloudFortified,
    partner: appListingGql.partner,
    compliantStandards: trustDataApi.compliantStandards,
    dataAccessNStorage: trustDataApi.dataAccessNStorage,
    thirdPartyInformation: trustDataApi.thirdPartyInformation,
    dataResidency: trustDataApi.dataResidency,
    dataRetention: trustDataApi.dataRetention,
    logDetails: trustDataApi.logDetails
  };
};
export default appTrustDataAdapter;